import * as React from 'react';

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  /** The panel's width; most dialogs are narrow, a search with answers is wider. */
  widthClassName?: string;
}

export const Dialog: React.FC<DialogProps> = ({ open, onOpenChange, children, widthClassName = 'max-w-lg' }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1300] flex items-center justify-center p-4">
      {/* Ink at 50% (a Tailwind opacity modifier compiles to nothing on a var() token) */}
      <div
        className="fixed inset-0"
        style={{ backgroundColor: 'color-mix(in srgb, var(--ink) 50%, transparent)' }}
        onClick={() => onOpenChange(false)}
      />
      <div className={`relative z-[1300] w-full ${widthClassName}`}>
        {children}
      </div>
    </div>
  );
};

interface DialogContentProps {
  children: React.ReactNode;
  className?: string;
}

export const DialogContent: React.FC<DialogContentProps> = ({ children, className = '' }) => {
  return (
    <div className={`modal-panel p-6 ${className}`}>
      {children}
    </div>
  );
};

interface DialogHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({ children, className = '' }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
};

interface DialogTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const DialogTitle: React.FC<DialogTitleProps> = ({ children, className = '' }) => {
  return (
    <h2 className={`heading-3 ${className}`}>
      {children}
    </h2>
  );
};

interface DialogFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const DialogFooter: React.FC<DialogFooterProps> = ({ children, className = '' }) => {
  return (
    <div className={`mt-6 flex justify-end space-x-2 ${className}`}>
      {children}
    </div>
  );
};